import React from 'react';
import { IndianRupee, X } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export const MaterialRequestHeader = ({ project, projects = [], onProjectChange, estimatedValue, onClose, isEditing }) => {
  return (
    <div className="shrink-0 px-6 sm:px-8 py-5 sm:py-6 border-b border-slate-100 flex items-center justify-between bg-white relative gap-4">
      <div className="flex flex-col gap-1 w-full max-w-[300px]">
        <h2 className="font-semibold text-[15px] text-brand-dark">
          {isEditing ? "Update Material Request" : "Request New Material"}
        </h2>
        {project ? (
          <div className="flex items-center gap-2">
            <span className="text-[11px] font-bold text-[#f97316] uppercase tracking-wider font-poppins">
              PROJECT: {project?.projectId || 'N/A'}
            </span>
            <div className="w-1 h-1 rounded-full bg-slate-200" />
            <span className="text-[11px] font-semibold text-slate-400 uppercase tracking-wider font-poppins">
              {project?.customerName || 'VERVE KITCHENS'}
            </span>
          </div>
        ) : (
          <select 
            onChange={(e) => {
              const selected = projects.find(p => p._id === e.target.value);
              if (selected) onProjectChange(selected);
            }}
            className="mt-1 w-full bg-slate-50 border border-slate-200 px-3 py-1.5 rounded-lg text-[11px] font-bold text-[#f97316] outline-none focus:border-blue-500 transition-all uppercase tracking-wider font-poppins"
          >
            <option value="">Select Project...</option>
            {projects.map(p => (
              <option key={p._id} value={p._id}>{p.projectId} - {p.customerName}</option>
            ))}
          </select>
        )}
      </div>

      <div className="flex items-center gap-6">
        <div className="hidden md:flex flex-col items-end">
          <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">
            Estimated Value
          </span>
          <div className="flex items-center gap-1.5 bg-emerald-50 text-emerald-600 px-4 py-1.5 rounded-xl border border-emerald-100">
            <IndianRupee className="w-3.5 h-3.5 stroke-[3]" />
            <span className="text-lg font-black tracking-tight">
              {estimatedValue.toLocaleString('en-IN')}
            </span>
          </div>
        </div>

        <button
          onClick={onClose}
          className="w-8 h-8 flex items-center justify-center text-slate-500 transition-all cursor-pointer"
          id="close-modal-btn"
        >
          <X size={24} strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
};
